import { render, staticRenderFns } from "./edit-brand.vue?vue&type=template&id=fb640fd8&"
import script from "./edit-brand.vue?vue&type=script&lang=js&"
export * from "./edit-brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports